export const fieldsList = [
  "full_name",
  "donor_id",
  "phone_number",
  "email",
  "date_of_birth",
  "donation_amount",
  "contact_id",
  "umrn_no",
  "status",
  "patronship_level",
  "processing_agency",
  "address",
  "city",
  "state",
  "zip_code",
  "country",
  "gender",
  "occupation",
  "account_holder_name",
  "want_80g",
  "micr",
  "start_date",
  "remarks",
  "donation_frequency",
  "mode",
  "deduction_day",
  "bank_account_no",
  "bank_name",
  "bank_branch",
  "bank_ifsc",
  "total_donation",
  "tr_number",
  "manual_type",
  "depository_bank",
  "pan_no",
  "donation_type",
  "utility_code",
  "is_booked_calendar",
  "is_address_confirmed"
];
